import { PELabFrontendCommon } from './common/common';
jQuery(document).ready(function($){

  PELabFrontendCommon($)
});
